import { portalJWTRequest } from "./portalJWTRequest";

const errorLog = (error) => {
  console.error(JSON.stringify(error));
  return Promise.reject(error);
};

class RequestManager {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  request(url, method, requestName, body) {
    let request = null;
    const appType = window.vidyoApp?.getMode?.() === 0 ? "DESKTOP" : "WEB";
    switch (appType) {
      case "DESKTOP":
        request = this.desktopRequest(url, method, requestName, body);
        break;
      case "WEB":
        request = this.webRequest(url, method, requestName, body);
        break;

      default:
        break;
    }
    return request;
  }

  // TODO implement in Web project
  async webRequest(url, method, requestName, body) {
    try {
      const URL = `${this.baseUrl}${url}`;
      /////////////////
      const options = {
        url: URL,
        method: method,
        headers: {
          Accept: "application/json",
        },
      };
      if (body) {
        options.data = body;
      }
      console.info(`Start request: requestName=${requestName}, URL=${URL}`);
      //////////////////

      const res = await portalJWTRequest(options);

      return res.data;
    } catch (error) {
      return errorLog(error);
    }
  }

  //todo implement in desktop project
  async desktopRequest(url, method, requestName, body, moderatorPin) {
    try {
      return Promise.resolve({});
    } catch (error) {}
  }
}

export { errorLog, RequestManager };
